module.exports = __webpack_public_path__ + "img/_magic-dagger_.4bf82f98.svg";